module.exports = __webpack_public_path__ + "static/media/6.b0a2c731.jpg";